exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#qrCode{-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;width:100vw;height:100vh;position:absolute;left:0;top:0;z-index:4}#qrCode,.qr-container{display:-webkit-flex;display:-ms-flex;display:flex}.qr-container{-webkit-align-items:flex-end;align-items:flex-end;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;padding:20px;background-color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/styles/wechat-qr.css
// module id = 235
// module chunks = 0